import React from "react";
import Headertop from '../components/Headertop';
import Navbar from '../components/Navbar';
import Header from '../components/Header-Course';
import Footer from '../components/Footer';
import { Link } from "react-router-dom";

import paper1 from '../components/question-answer-pdf/1__IIT-JAM 2005.pdf';
import paper2 from '../components/question-answer-pdf/2__IIT-JAM 2006.pdf';
import paper3 from '../components/question-answer-pdf/3__IIT-JAM 2007.pdf';
import paper4 from '../components/question-answer-pdf/4__IIT-JAM 2008.pdf';
import paper5 from '../components/question-answer-pdf/5__IIT-JAM 2009.pdf';
import paper6 from '../components/question-answer-pdf/6__IIT-JAM 2010.pdf';
import paper7 from '../components/question-answer-pdf/7__IIT-JAM 2011.pdf';
import paper8 from '../components/question-answer-pdf/8__IIT-JAM 2012.pdf';
import paper9 from '../components/question-answer-pdf/9__IIT-JAM 2013.pdf';
import paper10 from '../components/question-answer-pdf/10__IIT-JAM 2014.pdf';
import paper11 from '../components/question-answer-pdf/11__IIT-JAM 2015.pdf';
import paper12 from '../components/question-answer-pdf/12__IIT-JAM 2016.pdf';
import paper13 from '../components/question-answer-pdf/13__IIT-JAM 2017.pdf';
import paper14 from '../components/question-answer-pdf/14__IIT-JAM 2018.pdf';
import paper15 from '../components/question-answer-pdf/15__IIT-JAM 2019.pdf';
import paper16 from '../components/question-answer-pdf/16__IIT-JAM 2020.pdf';
import paper17 from '../components/question-answer-pdf/17__IIT-JAM 2021.pdf';
import paper18 from '../components/question-answer-pdf/18__IIT-JAM 2022.pdf';
import paper19 from '../components/question-answer-pdf/19__IIT-JAM 2023.pdf';
import paper20 from '../components/question-answer-pdf/20__IIT-JAM 2024.pdf';
import paper21 from '../components/question-answer-pdf/21__IIT-JAM 2025.pdf';

function CSIRNETCourses (){
    return (
        <>
            <Headertop /> 
            <Navbar />
            <Header />
            <div className="container my-5">
                <div className="row g-4">
                    <div className="col-lg-9">
                        <div className="row g-4">
                            <p>Solving IIT JAM Previous Year Paper is one of the best ways to boost your preparation for the exam. The IIT JAM is a highly competitive test that evaluates the knowledge and research aptitude in science subjects of a candidate. Practicing IIT JAM Previous Year Question Papers helps aspirants understand the exam pattern, difficulty level and frequently asked topics. It also improves time management and problem-solving skills, making preparation more effective. With Vigyan Vriksh expert-curated IIT JAM Previous Year Question Papers with solutions PDF, candidates can revise systematically, reduce errors and enhance their chances of scoring higher.</p>
                            <p><b>IIT JAM Chemistry Question Paper (Total Tests: 8)</b></p>
                        </div>

                        <div className="downloadcards mb-3">
                            <div className="downloadcardsinner d-flex justify-content-between align-items-center">
                                <div className="">
                                    <span className="badge bg-warning text-dark mb-2 rounded-1 px-2 py-1">PRO</span>
                                    <h5 className="fw-bold mb-1">IIT JAM Exam 2005</h5>
                                </div>
                                <div className="d-flex gap-2">
                                    <Link to={paper1} rel="noopener noreferrer" target="_blank" className="btn btn-outline-danger downloadbtn">Download PDF</Link>
                                    <button className="btn btn-outline-denger downloadbtn"><i className="bi bi-lock-fill me-1"></i> Unlock Now</button>
                                </div>
                            </div>
                        </div>

                        <div className="downloadcards mb-3">
                            <div className="downloadcardsinner d-flex justify-content-between align-items-center">
                                <div className="">
                                    <span className="badge bg-warning text-dark mb-2 rounded-1 px-2 py-1">PRO</span>
                                    <h5 className="fw-bold mb-1">IIT JAM Exam 2006</h5>
                                </div>
                                <div className="d-flex gap-2">
                                    <Link to={paper2} rel="noopener noreferrer" target="_blank" className="btn btn-outline-danger downloadbtn">Download PDF</Link>
                                    <button className="btn btn-outline-denger downloadbtn"><i className="bi bi-lock-fill me-1"></i> Unlock Now</button>
                                </div>
                            </div>
                        </div>

                        <div className="downloadcards mb-3">
                            <div className="downloadcardsinner d-flex justify-content-between align-items-center">
                                <div className="">
                                    <span className="badge bg-warning text-dark mb-2 rounded-1 px-2 py-1">PRO</span>
                                    <h5 className="fw-bold mb-1">IIT JAM Exam 2007</h5>
                                </div>
                                <div className="d-flex gap-2">
                                    <Link to={paper3} rel="noopener noreferrer" target="_blank" className="btn btn-outline-danger downloadbtn">Download PDF</Link>
                                    <button className="btn btn-outline-denger downloadbtn"><i className="bi bi-lock-fill me-1"></i> Unlock Now</button>
                                </div>
                            </div>
                        </div>

                        <div className="downloadcards mb-3">
                            <div className="downloadcardsinner d-flex justify-content-between align-items-center">
                                <div className="">
                                    <span className="badge bg-warning text-dark mb-2 rounded-1 px-2 py-1">PRO</span>
                                    <h5 className="fw-bold mb-1">IIT JAM Exam 2008</h5>
                                </div>
                                <div className="d-flex gap-2">
                                    <Link to={paper4} rel="noopener noreferrer" target="_blank" className="btn btn-outline-danger downloadbtn">Download PDF</Link>
                                    <button className="btn btn-outline-denger downloadbtn"><i className="bi bi-lock-fill me-1"></i> Unlock Now</button>
                                </div>
                            </div>
                        </div>

                        <div className="downloadcards mb-3">
                            <div className="downloadcardsinner d-flex justify-content-between align-items-center">
                                <div className="">
                                    <span className="badge bg-warning text-dark mb-2 rounded-1 px-2 py-1">PRO</span>
                                    <h5 className="fw-bold mb-1">IIT JAM Exam 2009</h5>
                                </div>
                                <div className="d-flex gap-2">
                                    <Link to={paper5} rel="noopener noreferrer" target="_blank" className="btn btn-outline-danger downloadbtn">Download PDF</Link>
                                    <button className="btn btn-outline-denger downloadbtn"><i className="bi bi-lock-fill me-1"></i> Unlock Now</button>
                                </div>
                            </div>
                        </div>

                        <div className="downloadcards mb-3">
                            <div className="downloadcardsinner d-flex justify-content-between align-items-center">
                                <div className="">
                                    <span className="badge bg-warning text-dark mb-2 rounded-1 px-2 py-1">PRO</span>
                                    <h5 className="fw-bold mb-1">IIT JAM Exam 2010</h5>
                                </div>
                                <div className="d-flex gap-2">
                                    <Link to={paper6} rel="noopener noreferrer" target="_blank" className="btn btn-outline-danger downloadbtn">Download PDF</Link>
                                    <button className="btn btn-outline-denger downloadbtn"><i className="bi bi-lock-fill me-1"></i> Unlock Now</button>
                                </div>
                            </div>
                        </div>

                        <div className="downloadcards mb-3">
                            <div className="downloadcardsinner d-flex justify-content-between align-items-center">
                                <div className="">
                                    <span className="badge bg-warning text-dark mb-2 rounded-1 px-2 py-1">PRO</span>
                                    <h5 className="fw-bold mb-1">IIT JAM Exam 2011</h5>
                                </div>
                                <div className="d-flex gap-2">
                                    <Link to={paper7} rel="noopener noreferrer" target="_blank" className="btn btn-outline-danger downloadbtn">Download PDF</Link>
                                    <button className="btn btn-outline-denger downloadbtn"><i className="bi bi-lock-fill me-1"></i> Unlock Now</button>
                                </div>
                            </div>
                        </div>

                        <div className="downloadcards mb-3">
                            <div className="downloadcardsinner d-flex justify-content-between align-items-center">
                                <div className="">
                                    <span className="badge bg-warning text-dark mb-2 rounded-1 px-2 py-1">PRO</span>
                                    <h5 className="fw-bold mb-1">IIT JAM Exam 2012</h5>
                                </div>
                                <div className="d-flex gap-2">
                                    <Link to={paper8} rel="noopener noreferrer" target="_blank" className="btn btn-outline-danger downloadbtn">Download PDF</Link>
                                    <button className="btn btn-outline-denger downloadbtn"><i className="bi bi-lock-fill me-1"></i> Unlock Now</button>
                                </div>
                            </div>
                        </div>

                        <div className="downloadcards mb-3">
                            <div className="downloadcardsinner d-flex justify-content-between align-items-center">
                                <div className="">
                                    <span className="badge bg-warning text-dark mb-2 rounded-1 px-2 py-1">PRO</span>
                                    <h5 className="fw-bold mb-1">IIT JAM Exam 2013</h5>
                                </div>
                                <div className="d-flex gap-2">
                                    <Link to={paper9} rel="noopener noreferrer" target="_blank" className="btn btn-outline-danger downloadbtn">Download PDF</Link>
                                    <button className="btn btn-outline-denger downloadbtn"><i className="bi bi-lock-fill me-1"></i> Unlock Now</button>
                                </div>
                            </div>
                        </div>

                        <div className="downloadcards mb-3">
                            <div className="downloadcardsinner d-flex justify-content-between align-items-center">
                                <div className="">
                                    <span className="badge bg-warning text-dark mb-2 rounded-1 px-2 py-1">PRO</span>
                                    <h5 className="fw-bold mb-1">IIT JAM Exam 2014</h5>
                                </div>
                                <div className="d-flex gap-2">
                                    <Link to={paper10} rel="noopener noreferrer" target="_blank" className="btn btn-outline-danger downloadbtn">Download PDF</Link>
                                    <button className="btn btn-outline-denger downloadbtn"><i className="bi bi-lock-fill me-1"></i> Unlock Now</button>
                                </div>
                            </div>
                        </div>

                        <div className="downloadcards mb-3">
                            <div className="downloadcardsinner d-flex justify-content-between align-items-center">
                                <div className="">
                                    <span className="badge bg-warning text-dark mb-2 rounded-1 px-2 py-1">PRO</span>
                                    <h5 className="fw-bold mb-1">IIT JAM Exam 2015</h5>
                                </div>
                                <div className="d-flex gap-2">
                                    <Link to={paper11} rel="noopener noreferrer" target="_blank" className="btn btn-outline-danger downloadbtn">Download PDF</Link>
                                    <button className="btn btn-outline-denger downloadbtn"><i className="bi bi-lock-fill me-1"></i> Unlock Now</button>
                                </div>
                            </div>
                        </div>

                        <div className="downloadcards mb-3">
                            <div className="downloadcardsinner d-flex justify-content-between align-items-center">
                                <div className="">
                                    <span className="badge bg-warning text-dark mb-2 rounded-1 px-2 py-1">PRO</span>
                                    <h5 className="fw-bold mb-1">IIT JAM Exam 2016</h5>
                                </div>
                                <div className="d-flex gap-2">
                                    <Link to={paper12} rel="noopener noreferrer" target="_blank" className="btn btn-outline-danger downloadbtn">Download PDF</Link>
                                    <button className="btn btn-outline-denger downloadbtn"><i className="bi bi-lock-fill me-1"></i> Unlock Now</button>
                                </div>
                            </div>
                        </div>

                        <div className="downloadcards mb-3">
                            <div className="downloadcardsinner d-flex justify-content-between align-items-center">
                                <div className="">
                                    <span className="badge bg-warning text-dark mb-2 rounded-1 px-2 py-1">PRO</span>
                                    <h5 className="fw-bold mb-1">IIT JAM Exam 2017</h5>
                                </div>
                                <div className="d-flex gap-2">
                                    <Link to={paper13} rel="noopener noreferrer" target="_blank" className="btn btn-outline-danger downloadbtn">Download PDF</Link>
                                    <button className="btn btn-outline-denger downloadbtn"><i className="bi bi-lock-fill me-1"></i> Unlock Now</button>
                                </div>
                            </div>
                        </div>

                        <div className="downloadcards mb-3">
                            <div className="downloadcardsinner d-flex justify-content-between align-items-center">
                                <div className="">
                                    <span className="badge bg-warning text-dark mb-2 rounded-1 px-2 py-1">PRO</span>
                                    <h5 className="fw-bold mb-1">IIT JAM Exam 2018</h5>
                                </div>
                                <div className="d-flex gap-2">
                                    <Link to={paper14} rel="noopener noreferrer" target="_blank" className="btn btn-outline-danger downloadbtn">Download PDF</Link>
                                    <button className="btn btn-outline-denger downloadbtn"><i className="bi bi-lock-fill me-1"></i> Unlock Now</button>
                                </div>
                            </div>
                        </div>

                        <div className="downloadcards mb-3">
                            <div className="downloadcardsinner d-flex justify-content-between align-items-center">
                                <div className="">
                                    <span className="badge bg-warning text-dark mb-2 rounded-1 px-2 py-1">PRO</span>
                                    <h5 className="fw-bold mb-1">IIT JAM Exam 2019</h5>
                                </div>
                                <div className="d-flex gap-2">
                                    <Link to={paper15} rel="noopener noreferrer" target="_blank" className="btn btn-outline-danger downloadbtn">Download PDF</Link>
                                    <button className="btn btn-outline-denger downloadbtn"><i className="bi bi-lock-fill me-1"></i> Unlock Now</button>
                                </div>
                            </div>
                        </div>

                        <div className="downloadcards mb-3">
                            <div className="downloadcardsinner d-flex justify-content-between align-items-center">
                                <div className="">
                                    <span className="badge bg-warning text-dark mb-2 rounded-1 px-2 py-1">PRO</span>
                                    <h5 className="fw-bold mb-1">IIT JAM Exam 2020</h5>
                                </div>
                                <div className="d-flex gap-2">
                                    <Link to={paper16} rel="noopener noreferrer" target="_blank" className="btn btn-outline-danger downloadbtn">Download PDF</Link>
                                    <button className="btn btn-outline-denger downloadbtn"><i className="bi bi-lock-fill me-1"></i> Unlock Now</button>
                                </div>
                            </div>
                        </div>

                        <div className="downloadcards mb-3">
                            <div className="downloadcardsinner d-flex justify-content-between align-items-center">
                                <div className="">
                                    <span className="badge bg-warning text-dark mb-2 rounded-1 px-2 py-1">PRO</span>
                                    <h5 className="fw-bold mb-1">IIT JAM Exam 2021</h5>
                                </div>
                                <div className="d-flex gap-2">
                                    <Link to={paper17} rel="noopener noreferrer" target="_blank" className="btn btn-outline-danger downloadbtn">Download PDF</Link>
                                    <button className="btn btn-outline-denger downloadbtn"><i className="bi bi-lock-fill me-1"></i> Unlock Now</button>
                                </div>
                            </div>
                        </div>

                        <div className="downloadcards mb-3">
                            <div className="downloadcardsinner d-flex justify-content-between align-items-center">
                                <div className="">
                                    <span className="badge bg-warning text-dark mb-2 rounded-1 px-2 py-1">PRO</span>
                                    <h5 className="fw-bold mb-1">IIT JAM Exam 2022</h5>
                                </div>
                                <div className="d-flex gap-2">
                                    <Link to={paper18} rel="noopener noreferrer" target="_blank" className="btn btn-outline-danger downloadbtn">Download PDF</Link>
                                    <button className="btn btn-outline-denger downloadbtn"><i className="bi bi-lock-fill me-1"></i> Unlock Now</button>
                                </div>
                            </div>
                        </div>

                        <div className="downloadcards mb-3">
                            <div className="downloadcardsinner d-flex justify-content-between align-items-center">
                                <div className="">
                                    <span className="badge bg-warning text-dark mb-2 rounded-1 px-2 py-1">PRO</span>
                                    <h5 className="fw-bold mb-1">IIT JAM Exam 2023</h5>
                                </div>
                                <div className="d-flex gap-2">
                                    <Link to={paper19} rel="noopener noreferrer" target="_blank" className="btn btn-outline-danger downloadbtn">Download PDF</Link>
                                    <button className="btn btn-outline-denger downloadbtn"><i className="bi bi-lock-fill me-1"></i> Unlock Now</button>
                                </div>
                            </div>
                        </div>

                        <div className="downloadcards mb-3">
                            <div className="downloadcardsinner d-flex justify-content-between align-items-center">
                                <div className="">
                                    <span className="badge bg-warning text-dark mb-2 rounded-1 px-2 py-1">PRO</span>
                                    <h5 className="fw-bold mb-1">IIT JAM Exam 2024</h5>
                                </div>
                                <div className="d-flex gap-2">
                                    <Link to={paper20} rel="noopener noreferrer" target="_blank" className="btn btn-outline-danger downloadbtn">Download PDF</Link>
                                    <button className="btn btn-outline-denger downloadbtn"><i className="bi bi-lock-fill me-1"></i> Unlock Now</button>
                                </div>
                            </div>
                        </div>

                        <div className="downloadcards mb-3">
                            <div className="downloadcardsinner d-flex justify-content-between align-items-center">
                                <div className="">
                                    <span className="badge bg-warning text-dark mb-2 rounded-1 px-2 py-1">PRO</span>
                                    <h5 className="fw-bold mb-1">IIT JAM Exam 2025</h5>
                                </div>
                                <div className="d-flex gap-2">
                                    <Link to={paper21} rel="noopener noreferrer" target="_blank" className="btn btn-outline-danger downloadbtn">Download PDF</Link>
                                    <button className="btn btn-outline-denger downloadbtn"><i className="bi bi-lock-fill me-1"></i> Unlock Now</button>
                                </div>
                            </div>
                        </div>

                        <p>IIT JAM 2027: The IIT JAM 2027 (Joint Admission Test for M.Sc.) notification is expected soon, opening the gateway for admission to postgraduate science programs at prestigious IITs and IISc. This exam evaluates candidates in subjects like Mathematics, Physics, Chemistry, and Life Sciences, testing both conceptual understanding and analytical skills. Aspirants can prepare by understanding the eligibility criteria, detailed syllabus, and exam pattern, ensuring they are well-equipped for this highly competitive test.</p>

                        <h4 className="mt-3">IIT JAM 2027 Overview</h4>
                        <p>IIT JAM 2027 (Joint Admission Test for M.Sc.) is a national-level exam for admission to postgraduate science programs at IITs and IISc. It tests candidates in subjects like Mathematics, Physics, Chemistry, and Life Sciences through a computer-based test. The exam evaluates both conceptual understanding and problem-solving skills, helping aspirants secure seats in top institutes.</p>

                        <table className="table table-bordered">
                            <tbody>
                                <tr><th colspan={2}>IIT JAM 2027 Overview</th></tr>
                                <tr><td>Exam Feature</td><td>Details</td></tr>
                                <tr><td>Exam Name</td><td>IIT JAM 2027 (Joint Admission Test for M.Sc.)</td></tr>
                                <tr><td>Mode of Exam</td><td>Online (Computer-Based Test)</td></tr>
                                <tr><td>Subjects Offered</td><td>Physics, Chemistry, Mathematics, Mathematical Statistics, Biotechnology, Geology, Life Sciences</td></tr>
                                <tr><td>Eligibility</td><td>Bachelor’s degree in relevant field from a recognized university</td></tr>
                                <tr><td>Exam Duration</td><td>3 hours</td></tr>
                                <tr><td>Question Type</td><td>Multiple Choice Questions (MCQs), Multiple Select Questions (MSQs), Numerical Answer Type (NAT)</td></tr>
                                <tr><td>Total Marks</td><td>100</td></tr>
                                <tr><td>Official Website</td><td>jam.iitb.ac.in</td></tr>
                                <tr><td>Notification Release</td><td>Expected Soon</td></tr>
                            </tbody>
                        </table>

                        <h4 className="mt-3">IIT JAM 2027 Expected Dates</h4>
                        <p>The IIT JAM 2027 exam schedule is expected to follow the usual timeline, with applications likely starting in February 2026 and the exam conducted in February 2027. Candidates should keep track of official announcements to stay updated on exact dates for registration, admit cards, and results.</p>
                        <table className="table table-bordered">
                            <tbody>
                                <tr><th colspan={2}>IIT JAM 2027 Expected Dates</th></tr>
                                <tr><td>IIT JAM 2027 Events</td><td>Tentative Dates</td></tr>
                                <tr><td>Notification Out</td><td>2nd week of September 2026</td></tr>
                                <tr><td>Application Form Start</td><td>2nd week of September 2026</td></tr>
                                <tr><td>Application Form End</td><td>2nd week of October 2026</td></tr>
                                <tr><td>Admit Card</td><td>Last week of January 2027</td></tr>
                                <tr><td>Exam Date</td><td>1 February 2027</td></tr>
                                <tr><td>Provisional Answer Key</td><td>Last week of February 2027</td></tr>
                                <tr><td>Final Answer Key</td><td>2nd week of March 2027</td></tr>
                                <tr><td>Result</td><td>Last week of March 2027</td></tr>
                                <tr><td>Cut Off</td><td>Last week of March 2027</td></tr>
                            </tbody>
                        </table>

                        <h4 className="mt-3">IIT JAM 2027 Exam Dates</h4>
                        <p>The IIT JAM 2027 exam is expected to be conducted in February 2027, following the typical schedule of previous years. While the exact dates will be confirmed in the official notification, aspirants should plan their preparation and revision accordingly. Other key milestones like admit card release, answer key, and result declaration will be announced by the exam authorities closer to the exam date.</p>

                        <h4 className="mt-3">IIT JAM 2027 Form Date</h4>
                        <p>The online application process for IIT JAM 2027 is likely to begin in 2nd week of September 2026. Candidates must complete the registration and submit their forms before the last date, which is usually in March 2026. Early registration is recommended to avoid last-minute issues and to ensure a smooth application process.</p>

                        <h4 className="mt-3">IIT JAM 2027 Eligibility</h4>
                        <p>To appear for IIT JAM 2027 and seek admission to MSc, MSc-PhD, MS (Research), or other postgraduate programs at IITs, IISc, and participating institutes, candidates must meet certain academic requirements.</p>
                        <p><b>Educational Qualification</b></p>
                        <p>Candidates should have completed or be in the final year of their undergraduate degree in 2026. Admission will be based on qualifying for JAM 2026.</p>
                        <p><b>Important Conditions</b></p>
                        <ul className="list-unstyled small text-muted mt-3">
                            <li><i className="bi bi-mortarboard-fill"></i> The undergraduate degree must be completed before admission.</li>
                            <li><i className="bi bi-mortarboard-fill"></i> Candidates must provide proof of passing and all necessary documents.</li>
                            <li><i className="bi bi-mortarboard-fill"></i> Minimum eligibility (subjects, marks, degree type) is set by the admitting institute.</li>
                            <li><i className="bi bi-mortarboard-fill"></i> All documents must be submitted by the institute’s deadline; late submission may cancel admission.</li>
                        </ul>
                        <p><b>For Final Year Students</b></p>
                        <p>Provisional admission is allowed for those in the final year, but they must submit final mark sheets, a degree certificate, and any other required documents before confirmation. Also, the more exact information will be provided once the notification is out officially.</p>


                        <h4 className="mt-3">IIT JAM 2027 Subjects and Syllabus</h4> 
                        <p>IIT JAM 2027 offers admission into M.Sc. (Two Years), Joint M.Sc.-Ph.D., and M.Sc.-Ph.D. Dual Degree, and other post-bachelor’s programs at the IITs in the following subjects:</p>
                        <ul className="list-unstyled small text-muted mt-3">
                            <li><i className="bi bi-mortarboard-fill"></i> Biotechnology (BT)</li>
                            <li><i className="bi bi-mortarboard-fill"></i> Chemistry (CY)</li>
                            <li><i className="bi bi-mortarboard-fill"></i> Economics (EN)</li>
                            <li><i className="bi bi-mortarboard-fill"></i> Geology (GG)</li>
                            <li><i className="bi bi-mortarboard-fill"></i> Mathematics (MA)</li>
                            <li><i className="bi bi-mortarboard-fill"></i> Mathematical Statistics (MS)</li>
                            <li><i className="bi bi-mortarboard-fill"></i> Physics (PH)</li>
                        </ul>

                        <table className="table table-bordered">
                            <tbody>
                                <tr><th colspan={2}>IIT JAM 2027 Subjects and Syllabus</th></tr>
                                <tr><td>Subject	Key</td><td>Topics Covered</td></tr>
                                <tr><td>Biotechnology (BT)</td><td>Biology (10+2+3 level), Chemistry (10+2+3 level), Mathematics (10+2 level), Physics (10+2 level)</td></tr>
                                <tr><td>Chemistry (CY)</td><td>Physical, Organic, and Inorganic Chemistry (10+2+3 level)</td></tr>
                                <tr><td>Economics (EN)</td><td>Microeconomics, Macroeconomics, Statistics, Mathematics, Indian Economy</td></tr>
                                <tr><td>Geology (GG)</td><td>Earth & Planetary System, Mineralogy, Petrology, Economic Geology, Paleontology</td></tr>
                                <tr><td>Mathematics (MA)</td><td>Sequences & Series, Differential Calculus, Integral Calculus, Vector Calculus, Linear Algebra, Group Theory</td></tr>
                                <tr><td>Mathematical Statistics (MS)</td><td>Probability, Random Variables, Standard Distributions, Joint Distributions, Sampling Distributions, Estimation, Hypothesis Testing</td></tr>
                                <tr><td>Physics (PH)</td><td>Mechanics, Electrodynamics, Quantum Mechanics, Thermodynamics, Modern Physics</td></tr>
                            </tbody>
                        </table>

                        <h4 className="mt-3">IIT JAM 2027 Paper Pattern</h4>
                        <table className="table table-bordered">
                            <tbody>
                                <tr><th colspan={2}>IIT JAM 2027 Paper Pattern</th></tr>
                                <tr><td>Parameter</td><td>Details</td></tr>
                                <tr><td>Mode</td><td>Online Computer-Based Test (CBT)</td></tr>
                                <tr><td>Duration</td><td>3 hours (180 minutes)</td></tr>
                                <tr><td>Question Types</td><td>MCQs, MSQs, Numerical Answer Type (NAT)</td></tr>
                                <tr><td>Total Questions & Marks</td><td>60 questions, 100 marks</td></tr>
                                <tr><td>Section A</td><td>30 MCQs
                                    <ul className="list-unstyled small text-muted mt-3">
                                        <li><i className="bi bi-mortarboard-fill"></i> 10 × 1 mark</li>
                                        <li><i className="bi bi-mortarboard-fill"></i> 20 × 2 marks</li>
                                        <li><i className="bi bi-mortarboard-fill"></i> Negative marking applicable</li>
                                    </ul>
                                </td></tr>
                                <tr><td>Section B</td><td>10 MSQs
                                    <ul className="list-unstyled small text-muted mt-3">
                                        <li><i className="bi bi-mortarboard-fill"></i> 2 marks each</li>
                                        <li><i className="bi bi-mortarboard-fill"></i> No negative marking</li>
                                    </ul>
                                </td></tr>
                                <tr><td>Section C</td><td>20 NATs
                                    <ul className="list-unstyled small text-muted mt-3">
                                        <li><i className="bi bi-mortarboard-fill"></i> 10 × 1 mark</li>
                                        <li><i className="bi bi-mortarboard-fill"></i> 10 × 2 marks</li>
                                        <li><i className="bi bi-mortarboard-fill"></i> No negative marking</li>
                                    </ul>
                                </td></tr>
                                <tr><td>Negative Marking</td><td>Only in Section A
                                    <ul className="list-unstyled small text-muted mt-3">
                                        <li><i className="bi bi-mortarboard-fill"></i> −1/3 for 1-mark questions</li>
                                        <li><i className="bi bi-mortarboard-fill"></i> −2/3 for 2-mark questions </li>
                                    </ul>
                                </td></tr>
                            </tbody>
                        </table>

                        <h4 className="mt-3">IIT JAM 2027 Marking Scheme</h4>
                        <p>The IIT JAM 2027 exam carries a total of 100 marks across three sections, with different marking rules:</p>
                            <table className="table table-bordered">
                                <tbody>
                                    <tr>
                                        <th colSpan={5}>IIT JAM 2027 Marking Scheme</th>
                                    </tr>
                                    <tr>
                                        <th>Section</th>
                                        <th>Question Type</th>
                                        <th>Number of Questions</th>
                                        <th>Marks per Question</th>
                                        <th>Negative Marking</th>
                                    </tr>
                                    <tr>
                                        <td>A</td>
                                        <td>MCQs</td>
                                        <td>30 (10 × 1, 20 × 2)</td>
                                        <td>1 & 2</td>
                                        <td>Yes (−1/3 for 1-mark, −2/3 for 2-mark)</td>
                                    </tr>
                                    <tr>
                                        <td>B</td>
                                        <td>MSQs</td>
                                        <td>10</td>
                                        <td>2</td>
                                        <td>No</td>
                                    </tr>
                                    <tr>
                                        <td>C</td>
                                        <td>NATs</td>
                                        <td>20(10 × 1, 10 × 2)</td>
                                        <td>1 & 2</td>
                                        <td>No</td>
                                    </tr>
                                </tbody>
                            </table>

                    </div>

                    <div className="col-lg-3">
                        <div className="sidebar-box">
                            <h5>Search</h5>
                            <div className="input-group mt-3">
                                <input type="text" className="form-control" placeholder="Enter Keyword" />
                                <button className="btn btn-light"><i className="bi bi-search"></i></button>
                            </div>
                        </div>
                        <div className="sidebar-box">
                            <h5>Recent Posts</h5>
                            <div className="recent-post mt-3">
                                <ul className="list-unstyled">
                                    <li><Link to="/Upgiclecturerrecruitment2025">UP GIC Lecturer Recruitment 2025 Apply Online, Eligibility, Fee, Last Date</Link></li>
                                    <li><Link to="/RPSCSchoollecturer2025">RPSC School Lecturer Recruitment 2025 [3225 Post] Apply Online</Link></li>
                                    <li><Link to="/GATEExamination2026">GATE Examination 2026</Link></li>
                                    <li><Link to="/BiharBPSCAESRecruitment2025">Read More</Link></li>
                                </ul>
                                <div>
                                    <p className="mb-0"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}
export default CSIRNETCourses;